module.exports = __webpack_public_path__ + "banquet/components/ShoppingCartPopover/images/nav_bag.8f2f27501034d35faf9f053598d0599b.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartPopover/images/nav_bag.svg
// module id = 1687
// module chunks = 1